import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CusInput from '../../../../../components/material-ui/CusInput';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import useNumberParams from '../../../../../hooks/useNumberParams';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';

export default function CasinoPlayersOnlineContent() {
  const { successToast } = useToast();
  const casinoId = useNumberParams('casinoId');
  const [initCountOnline, setInitCountOnline] = useState(null);

  useEffect(() => {
    API_CASINO.gamestat
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data || {};
        setInitCountOnline(data.gamersOnline);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    console.log('initCountOnline', initCountOnline);

    const gamersOnline = initCountOnline === '' ? null : +initCountOnline;
    API_CASINO.gamestat
      .set({ casinoId, data: { gamersOnline } })
      .then(() => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  console.log('initCountOnline', initCountOnline);

  return (
    <Stack gap={2}>
      <CusInput
        label={'Initial number of players online'}
        value={initCountOnline}
        onChange={(e) => setInitCountOnline(e.target.value)}
        type="number"
        inputSx={{ maxWidth: 250 }}
        inputProps={{ min: 0, max: 9999999 }}
        tooltipText={
          'The specified number + the actual number of online players is displayed on the casino website. An empty value hides the number of online players. From empty to integer, up to 7 characters long'
        }
      />
      <CasinoBtnSave onClick={onSaveClick} />
    </Stack>
  );
}
